import { UtilityConstants, UtilityReducer, UtilityActionTypes, UtilityOverview, GraphDateRange } from './types';

export const initialState: UtilityReducer = {
  isFetching: false,
  utilityOverview: {} as UtilityOverview,
  electricalGraphDateRange: {
    value: '30Days',
    label: 'Past 30 Days',
    startDatetime: undefined,
    endDatetime: undefined,
  },
  gasGraphDateRange: {
    value: '30Days',
    label: 'Past 30 Days',
    startDatetime: undefined,
    endDatetime: undefined,
  },
  weatherAdjusted: false,
  error: undefined,
};

export function utilityReducer(state: UtilityReducer = initialState, action: UtilityActionTypes) {
  switch (action.type) {
    case UtilityConstants.RequestUtilityOverview:
      return {
        ...state,
        isFetching: true,
      };
    case UtilityConstants.ReceiveUtilityOverview:
      const utilityOverview: UtilityOverview = action.payload as UtilityOverview;

      return {
        ...state,
        error: undefined,
        utilityOverview,
        isFetching: false,
      };
    case UtilityConstants.UpdateElectricalGraphDateRange:
      const electricalGraphDateRange: GraphDateRange = action.payload as GraphDateRange;
      return {
        ...state,
        electricalGraphDateRange,
      };
    case UtilityConstants.UpdateGasGraphDateRange:
      const gasGraphDateRange: GraphDateRange = action.payload as GraphDateRange;
      return {
        ...state,
        gasGraphDateRange,
      };
    case UtilityConstants.SetUtilityError:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    case UtilityConstants.UpdateWeatherAdjustedToggle:
      return {
        ...state,
        weatherAdjusted: action.payload,
      };
    default:
      return state;
  }
}
